import { providerLogger } from '@ragu-components/logger';
import { buildUrl, maybeThrowHttpError, validateStatus } from '@ragu-components/ord-providers';

import type { AxiosInstance } from 'axios';

export const executeSchedule = async (
  axiosInstance: AxiosInstance,
  realmId: string,
  scheduleId: string
): Promise<void> => {
  providerLogger.debug('executeSchedule', scheduleId);
  const url = `${buildUrl('schedules', { realmId, id: scheduleId })}/execute`;
  const response = await axiosInstance.post(url, undefined, { validateStatus });
  maybeThrowHttpError(response);
};
